import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { YearService } from '../../../../shared-components/year/year.service';
import { AccomodationBank } from '../../../sped-management/sped-management.model';
import { FormWithinDocumentsService } from '../../form-within-documents.service';
import { PickCourseOfStudy } from '../../formwithin-document-modal';

@Component({
  selector: 'app-pick-course-of-study',
  templateUrl: './pick-course-of-study.component.html',
  styleUrls: ['./pick-course-of-study.component.css']
})
export class PickCourseOfStudyComponent implements OnInit {
  dialogTitle = '';
  getCourceOfStudyData: PickCourseOfStudy[] = [];
  tempCourseOfStudyGrid: AccomodationBank[] = [];
  columnToDisplay = ['Checkbtn', 'Description'];
  tylerMatData = new TylerMatTableDataSource();
  allFormCheck = false;
  categoryDescription: string;
  yearId: number;
  studentXMLDataId: number;

  constructor(private formWithinDocumentService: FormWithinDocumentsService,
    private matDialogRef: MatDialogRef<PickCourseOfStudyComponent>,
    private yearService: YearService) { }

  ngOnInit(): void {
    this.yearId = this.yearService.defaultYear.Id;
    this.showgrid();
  }

  closeClick() {
    this.checkOutForm();
    this.matDialogRef.close();
  }

  showgrid() {
    this.tylerMatData = new TylerMatTableDataSource(this.tempCourseOfStudyGrid);
    this.tylerMatData.data = this.tempCourseOfStudyGrid;

  }
  saveClick() {
    this.formWithinDocumentService.courceOfStudyData.CategoryDescription = this.categoryDescription;
    this.formWithinDocumentService.saveCourseOfStudyData(this.yearId).subscribe(() => {
      this.closeClick();
    });
  }

  checkAllForms() {
    if (this.allFormCheck == true) {
      this.tempCourseOfStudyGrid.forEach(obj => {
        obj.Checked = true;
        if (this.categoryDescription == null || this.categoryDescription == undefined) {
          this.categoryDescription = obj.Description + '\n';
        }
        else {
          this.categoryDescription = this.categoryDescription + obj.Description + '\n';
        }
      });
    } else if (this.allFormCheck == false) {
      this.tempCourseOfStudyGrid.forEach(obj => {
        obj.Checked = false;
      });
    }
  }

  checkBoxClick(selected: AccomodationBank) {
    if (selected.Checked == true) {
      if (this.categoryDescription == null || this.categoryDescription == undefined) {
        this.categoryDescription = selected.Description + '\n';
      }
      else {
        this.categoryDescription = this.categoryDescription + selected.Description + '\n';
      }
    }
  }

  checkOutForm() {
    this.formWithinDocumentService.checkOutForm(this.studentXMLDataId, this.formWithinDocumentService.spedStudentCollectionTemplate.CheckOutByUserId, false).subscribe(() => {
    });
  }

}